module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_red-cross-a391f2b1a6510df7e370a727b35f1531.png";